import React, { createContext, ReactChild } from "react";
import { plugins, pluginOrdering } from "../plugins";
import PluginRegistry from "./PluginRegistry";
import { Placeholder, PlaceholderGroupMember, PluginData } from "./PluginRegistryTypes";

export interface PluginRegistryContextType {
  pluginRegistry: PluginRegistry;
  pluginOrdering: { [key in Placeholder | PlaceholderGroupMember]?: string[][] };
  allPluginsData: PluginData;
}

export const PluginRegistryContext = createContext<PluginRegistryContextType>({
  pluginRegistry: new PluginRegistry(),
  pluginOrdering: {},
  allPluginsData: { contentful: {} },
});

export interface PluginRegistryProviderProps {
  allPluginsData: PluginData;
  children?: ReactChild | ReactChild[] | undefined | null;
}

export const PluginRegistryProvider = (props: PluginRegistryProviderProps) => {
  const { allPluginsData, children } = props;
  const pluginRegistry = new PluginRegistry();
  for (const plugin of plugins) {
    plugin.init(pluginRegistry);
  }

  return (
    <PluginRegistryContext.Provider value={{ pluginRegistry, pluginOrdering, allPluginsData }}>
      {children}
    </PluginRegistryContext.Provider>
  );
};
